export const LOGO = 0;
export const STATEMENT_OF_EDUCATIONAL_PURPOSE = 1;
export const LOAN_DISCHARGE_FORM = 2;